<template>
  <ib-dialog
    :visible="visible"
    width="550px"
    empty-header
    @close="$emit('close')"
  >
    <ai-product-requests @close="$emit('close')" />
  </ib-dialog>
</template>

<script>
import AiProductRequests from '@/views/Home/AiAssistance/Components/AiProductRequests.vue'

export default {
  name: 'DialogPurchaseAiRequests',

  components: { AiProductRequests },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
